import { CheckoutStep } from "@features/checkout/types";
import type { ReactNode } from "react";
import { create } from "zustand";

export type ErrorMessageType = string | ReactNode | undefined;

export type CheckoutErrorStateStore = {
    errors: Record<CheckoutStep, ErrorMessageType>;
    setStepError: (stepName: CheckoutStep, errorMessage?: ErrorMessageType) => void;
    clearStepError: (stepName: CheckoutStep) => void;
    clearAllErrors: () => void;
};

const initialErrorState = {
    [CheckoutStep.CONTACT_DETAILS]: undefined,
    [CheckoutStep.DELIVERY]: undefined,
    [CheckoutStep.PAYMENT]: undefined,
};

export const useCheckoutErrorState = create<CheckoutErrorStateStore>((set) => ({
    errors: initialErrorState,
    setStepError: (stepName: CheckoutStep, errorMessage?: ErrorMessageType) =>
        set((state) => ({
            errors: {
                ...state.errors,
                [stepName]: errorMessage,
            },
        })),
    clearStepError: (stepName: CheckoutStep) =>
        set((state) => ({
            errors: {
                ...state.errors,
                [stepName]: undefined,
            },
        })),
    clearAllErrors: () =>
        set(() => ({
            errors: initialErrorState,
        })),
}));
